// Extracted types from schema.ts to avoid dependency on generated GraphQL types
import type { Money } from '@betterment/js-runtime';

export const ActivityItemStage = {
  Canceled: 'CANCELED',
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Initiated: 'INITIATED',
  Returned: 'RETURNED',
  Sent: 'SENT',
} as const;

export type ActivityItemStage = (typeof ActivityItemStage)[keyof typeof ActivityItemStage];

export const ActivityItemTradeSide = {
  Buy: 'BUY',
  Sell: 'SELL',
} as const;

export type ActivityItemTradeSide = (typeof ActivityItemTradeSide)[keyof typeof ActivityItemTradeSide];

type Security = {
  id: string;
  symbol: string;
  name?: string;
  __typename: 'SecurityFund' | 'SecurityStock';
  expenseRatio?: {
    explanation: string;
    value: number;
  };
  prospectusUrl?: string;
};

type SubAccount = {
  id: string;
  name: string;
  __typename: 'CashAccount' | 'DirectTradingAccount' | 'ManagedSubAccount' | 'Five29Account';
  legalAccount?: {
    id: string;
    displayName: string;
  };
};

export type ActivityItemStatus = {
  description?: string | null;
  message?: string | null;
  stage: ActivityItemStage;
  timestamp?: Date | null;
};

export type ActivityItemOrder = {
  __typename: 'ActivityItemOrder';
  description: string;
  timestamp: Date;
  amountRequested?: Money | null;
  amountTraded?: Money | null;
  sharesRequested?: string | null;
  sharesTraded?: string | null;
  sharePrice?: Money | null;
  tradeSide: ActivityItemTradeSide;
  activityReportsUrl?: string | null;
  security: Security;
  subAccount?: SubAccount | null;
  statuses: Array<ActivityItemStatus>;
};
